module.exports = __webpack_public_path__ + "img/dsn01.87695d7c.gif";